(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AgentSupplierContractSearch', AgentSupplierContractSearch);

    AgentSupplierContractSearch.$inject = ['$resource'];

    function AgentSupplierContractSearch($resource) {
        var resourceUrl = 'api/_search/agent-supplier-contracts/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
